import styled, { keyframes } from "styled-components";

const moveLines = () => keyframes`   
  3% {
    background-image: linear-gradient(-3deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    6% {
    background-image: linear-gradient(-6deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    9% {
    background-image: linear-gradient(-9deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    12% {
    background-image: linear-gradient(-12deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    15% {
    background-image: linear-gradient(-15deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    18% {
    background-image: linear-gradient(-18deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    21% {
    background-image: linear-gradient(-21deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    24% {
    background-image: linear-gradient(-24deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    27% {
    background-image: linear-gradient(-27deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    30% {
    background-image: linear-gradient(-30deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    33% {
    background-image: linear-gradient(-33deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    36% {
    background-image: linear-gradient(-36deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    39% {
    background-image: linear-gradient(-39deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    42% {
    background-image: linear-gradient(-42deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    45% {
    background-image: linear-gradient(-45deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    48% {
    background-image: linear-gradient(-48deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    51% {
    background-image: linear-gradient(-51deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    54% {
    background-image: linear-gradient(-54deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    57% {
    background-image: linear-gradient(-57deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    60% {
    background-image: linear-gradient(-60deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    63% {
    background-image: linear-gradient(-63deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    66% {
    background-image: linear-gradient(-66deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
  69% {
    background-image: linear-gradient(-69deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    72% {
    background-image: linear-gradient(-72deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    75% {
    background-image: linear-gradient(-75deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    78% {
    background-image: linear-gradient(-78deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    81% {
    background-image: linear-gradient(-81deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    84% {
    background-image: linear-gradient(-84deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    87% {
    background-image: linear-gradient(-87deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    90% {
    background-image: linear-gradient(-90deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    93% {
    background-image: linear-gradient(-93deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    96% {
    background-image: linear-gradient(-96deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }
    99% {
    background-image: linear-gradient(-99deg, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31, #11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31,#11182d, #131c31)
  }

  `

const transformY = (deg) => keyframes`   
  from {
    transform: rotate(${deg}) translate(0px,30px);
  }
  to {
    transform: rotate(${deg}) translate(0px,0px);
  }
`

export const MainBody = styled.div`
  overflow:hidden;
  position:relative;
  background-color: ${({ theme }) => theme.colors.primary};
  animation:  ${moveLines} 60s 0s linear forwards infinite;
  `

export const Container = styled.div`
  max-width: 1200px;
  margin: auto;
`

export const FlexContainer = styled.div`
  display: flex;
  justify-content: ${(props) => props.justify || ''};
  align-items: ${(props) => props.align || ''};
  margin-right: ${(props) => props.mRight || 0};
  gap: ${({ gap }) => gap};
  flex-direction: ${({ rowReverse }) => rowReverse ? 'row-reverse' : 'row'};

  & > div {
    flex: ${({ fullWidthChild }) => fullWidthChild && 1};
  }

  @media ${({ theme }) => theme.breakpoints.mobile}{
    margin-right: 0px;
    display: ${({ responsiveFlex }) => responsiveFlex ? 'flex' : 'block'};
    flex-direction: ${({ responsiveDirection }) => responsiveDirection};
    justify-content: ${(props) => props.responsivejustify || ''};
    // gap: ${({ responsivegap }) => responsivegap};
  }

  @media(max-width: 350px) {  
    gap: ${({ responsivegap2 }) => responsivegap2};    
  }
`

export const FlexContainerAlt = styled.div`
  display: flex;
  justify-content: ${(props) => props.justify | ''};
  align-items: ${(props) => props.align || ''};
  gap:25px;

  & > div {
    flex: ${({ fullWidthChild }) => fullWidthChild && 1};
  }

  @media ${({ theme }) => theme.breakpoints.mobile}{
    flex-direction: column-reverse;
    align-items: ${(props) => props.responsivealign || ''};
  }
`

export const PaddingContainer = styled.div`
  padding-top: ${({ top }) => top};
  padding-bottom: ${({ bottom }) => bottom};
  padding-left: ${({ left }) => left};
  padding-right: ${({ right }) => right};

  @media ${({ theme }) => theme.breakpoints.mobile}{
    padding-top: ${({ responsiveTop }) => responsiveTop};
    padding-bottom: ${({ responsiveBottom }) => responsiveBottom};
    padding-left: ${({ responsiveLeft }) => responsiveLeft};
    padding-right: ${({ responsiveRight }) => responsiveRight};
  }
`

export const Heading = styled(PaddingContainer)`
  color:${({ theme }) => theme.colors.white};
  text-align: ${({ align }) => align};
  font-size: ${({ size }) => {
    switch (size) {
      case 'h1':
        return '4rem';

      case 'h2':
        return '3rem';

      case 'h3':
        return '2rem';

      case 'h4':
        return '1rem';

      default:
        return;
    }
  }};
  font-weight: ${({ weight }) => weight || 'normal'};

  @media ${({ theme }) => theme.breakpoints.mobile}{
    text-align: ${({ responsivealign }) => responsivealign};
    font-size: ${({ size }) => {
    switch (size) {
      case 'h1':
        return '3rem';

      case 'h2':
        return '2rem';

      case 'h3':
        return '1.5rem';

      case 'h4':
        return '0.75rem';

      default:
        return;
    }
  }};

  @media(max-width: 350px) {
    font-size: ${({ size }) => {
    switch (size) {
      case 'h1':
        return '2.25rem';

      case 'h2':
        return '1.5rem';

      case 'h3':
        return '1.25rem';

      case 'h4':
        return '0.5625rem';

      default:
        return;
    }
  }};
  }
  }
`

export const BlueText = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`

export const ParaText = styled(PaddingContainer)`
  color: ${({ theme }) => theme.colors.para_text_color};
  line-height: 1.5rem;
  text-align: justify;

  @media ${({ theme }) => theme.breakpoints.mobile}{
    text-align: ${({ responsivealign }) => responsivealign};
  }
`

export const Particle = styled.img`
  position: absolute;
  top: ${({ initialTop }) => initialTop};
  left: ${({ initialLeft }) => initialLeft};
  right: ${({ initialRight }) => initialRight};
  bottom: ${({ initialBottom }) => initialBottom};
  animation:  ${props => transformY(props.rotate)} 3s ${({ delay }) => delay || 0}s linear infinite;
  animation-direction: alternate;
  opacity:0.25;

  @media (max-width: 767px) {
    width: 15%;
  }
`

export const IconContainer = styled.div`
    color: ${({ color, theme }) => {
    switch (color) {
      case 'white':
        return theme.colors.white;

      case 'blue':
        return theme.colors.secondary;

      default:
        return;
    }
  }};
    font-size: ${({ size }) => size};

    @media(max-width: 350px) {
    font-size: ${({ responsivesize2 }) => responsivesize2};
  }
`

export const IconContainerAlt = styled.div`
  color: ${({ color, theme }) => {
    switch (color) {
      case 'white':
        return theme.colors.white;

      case 'blue':
        return theme.colors.secondary;

      default:
        return;
    }
  }};
  font-size: ${({ size }) => size};
  display: none;

  @media (max-width: 767px) {
    display: block;
  }
`

export const Button = styled.a`
  display: inline-block;
  width: max-content;
  padding: 0.5rem 0.75rem;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primary_light};
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease; 

  &:hover{
    color: ${({ theme }) => theme.colors.primary_light};
    background-color: ${({ theme }) => theme.colors.white};
  }

  @media ${({ theme }) => theme.breakpoints.mobile}{
    margin: 0 ${({ setMXAuto }) => setMXAuto ? 'auto' : 0};
  }

  @media(max-width: 350px) {
    padding: ${({ responsivepadding2 }) => responsivepadding2}; 
    font-size: 14px;
  }
`

export const ButtonAlt = styled.button`
  display: inline-block;
  width: max-content;
  padding: 0.5rem 1rem;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primary_light};
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease; 

  &:hover{
    color: ${({ theme }) => theme.colors.primary_light};
    background-color: ${({ theme }) => theme.colors.white};
  }

  @media ${({ theme }) => theme.breakpoints.mobile}{
    margin: 0 ${({ setMXAuto }) => setMXAuto ? 'auto' : 0};
    padding: 0.25rem 0.5rem;
  }
`

export const ButtonAlt2 = styled.a`
  display: inline-block;
  font-size:16px;
  width: max-content;
  padding: 0.5rem 1rem;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primary_light};
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease; 

  &:hover{
    color: ${({ theme }) => theme.colors.primary_light};
    background-color: ${({ theme }) => theme.colors.white};
  }

  @media ${({ theme }) => theme.breakpoints.mobile}{
    margin: 0 ${({ setMXAuto }) => setMXAuto ? 'auto' : 0};
    padding: 0.25rem 0.5rem;
    font-size:14px;
  }
`